module.exports = __webpack_public_path__ + "static/media/cheesePizza.dd7a25a6.png";